import { render, staticRenderFns } from "./LoadAllBrands.vue?vue&type=template&id=6f0b9084&scoped=true&"
import script from "./LoadAllBrands.vue?vue&type=script&lang=js&"
export * from "./LoadAllBrands.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f0b9084",
  null
  
)

export default component.exports